import FleetCoachAppReleasesApi from "../../services/api/FleetCoachAppReleasesV2";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import { getPath } from "../../utils";

function handleError(err) {
  console.log("error: ", err);
}

export const setFleetCoachAppReleasesList = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_APP_RELEASES_LIST,
    payload,
  };
};

export const setFleetCoachAppReleasesActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_APP_RELEASES_ACTIVE_FILTERS,
    payload,
  };
};

export const getFleetCoachAppReleasesList =
  (filters = [], pageRequest = { page: 1, page_size: 10 }) =>
  async (dispatch) => {
    try {
      let body = {
        page_request: pageRequest,
        filters: filters,
      };

      dispatch(setLoader(true));
      let response =
        await FleetCoachAppReleasesApi.getFleetCoachAppReleasesList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setFleetCoachAppReleasesList(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getApkUploadUrl = (version) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachAppReleasesApi.getApkUploadUrl(version);
    const url = getPath(response, "upload_url", null);
    dispatch(setLoader(false));
    return url;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createAppRelease = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachAppReleasesApi.createAppRelease(payload);
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: "release created successfully",
        })
      );
    }
    dispatch(setLoader(false));
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const editAppRelease = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachAppReleasesApi.editAppRelease(
      payload.id,
      payload
    );
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: "release edited successfully",
        })
      );
      dispatch(setLoader(false));
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const launchAppRelease = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    if (payload.entities && payload.entities.length > 0) {
      for (var i = 0; i < payload.entities.length; i++) {
        if (typeof payload.entities[i] === "number") {
          payload.entities[i] = payload.entities[i].toString();
        }
      }
    }
    let response = await FleetCoachAppReleasesApi.launchAppRelease(
      payload.id,
      payload
    );
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "success",
        message: "release launched successfully",
      })
    );
  } catch (err) {
    dispatch(setLoader(true));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getApkDownloadUrl = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FleetCoachAppReleasesApi.getApkDownloadUrl(id);
    const url = getPath(response, "download_url", null);
    dispatch(setLoader(false));
    return url;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
